<template>
  <div class="spark-card day-placeholder-card no-locations-card">
    <div class="no-locations-content">
      <div class="no-locations-copy">
        <div class="day-placeholder-title no-locations-title">
          {{ localizeWithValues('sparks.no_locations.title', [cityName]) }}
        </div>
        <div class="day-placeholder-subtitle no-locations-subtitle">
          {{ localizeWithValues('sparks.no_locations.subtitle', [cityName]) }}
        </div>
      </div>

      <div class="no-locations-actions">
        <!--
        <GamButton
          :variant="GamButtonVariant.STEKLO"
          :size="GamButtonSize.SMALL"
          is-full-size
          is-centered
          @click="handleCreateSpark"
        >
          {{ localize('sparks.no_locations.create_spark') }}
        </GamButton>
        -->
        <GamButton
          :variant="GamButtonVariant.STEKLO"
          :size="GamButtonSize.SMALL"
          is-full-size
          is-centered
          @click="handleAddPlace"
        >
          {{ localize('sparks.no_locations.add_place') }}
        </GamButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterNameType } from '@/core/data/config/uiConfig.interface';
import { localize, localizeWithValues } from '@/core/gambits';
import { useCityStore } from '@/stores/city.store';
import { useMapStore } from '@/stores/map.store';
import GamButton from '@/views/components/GamButton.vue';
import { GamButtonSize, GamButtonVariant } from '@/views/composables/constants/components/gamButton.constants';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const cityStore = useCityStore();
const mapStore = useMapStore();
const { city } = storeToRefs(cityStore);
const cityName = computed(() => city.value?.name || 'Your City');

function handleAddPlace() {
  const coords = city.value?.coordinates;
  if (coords) {
    mapStore.setCurrentLocation({ lat: coords.lat, lng: coords.lng, zoom: 13 });
  }
  router.push({
    name: RouterNameType.LOCATIONS,
    query: {
      side_panel: 'add_location',
      mobile_step: 'pick_coordinate',
      ...(coords && { lat: String(coords.lat), lng: String(coords.lng) }),
    },
  });
}
</script>

<style lang="scss" scoped>
.no-locations-card {
  overflow: hidden;
}

.no-locations-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(100%, 17rem);
}

.no-locations-copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.45rem;
}

.day-placeholder-title {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--color-white-100);
}

.day-placeholder-subtitle {
  font-size: 13px;
  line-height: 1.3;
  letter-spacing: 0.01em;
  color: var(--color-white-40);
}

.no-locations-title {
  max-width: 15rem;
}

.no-locations-subtitle {
  max-width: 15rem;
  text-wrap: balance;
}

.no-locations-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.65rem;
  // width: min(100%, 12rem);
  margin-top: 2rem;
}
</style>
